/**
 * Kvota taqsimoti marshrutlari.
 *
 * Marshrut daraxti STATIK: uch rol (Moliya, Innovatsiya, OTM/ITM) uchun yo'llar
 * bir xil, faqat chiziladigan komponent farq qiladi va u QuoteDistributionRouter
 * ichida, foydalanuvchi yuklangandan keyin tanlanadi.
 *
 * Avval bu fayl `getQuoteDistributionForUser()` ni modul yuklanish paytida
 * chaqirardi. O'sha paytda foydalanuvchi hali yuklanmagan bo'lib, funksiya doim
 * `emptyPage` qaytarardi va `quote-distribution` nomli marshrut umuman
 * ro'yxatdan o'tmasdi - natijada menyudagi havola ishlamasdi.
 */

// Statik import: komponent juda kichik, alohida chunk qilishning ma'nosi yo'q.
// Lazy qilinsa, marshrutga kirganda avval shu chunk, keyin sahifa chunk'i -
// ikkita ketma-ket so'rov bo'lardi.
import QuoteDistributionRouter from '@/views/pages/quote-distribution/QuoteDistributionRouter.vue'

export default [
  {
    path: 'quote-distribution',
    name: 'quote-distribution',
    component: QuoteDistributionRouter,
    props: { variant: 'list' },
    meta: {
      pageTitle: 'Quote distribution',
      breadcrumb: [
        {
          text: 'Quote distribution',
          active: true,
        },
      ],
    },
    resource: 'Distribution',
  },
  {
    // Faqat Moliya rolida ishlatiladi
    path: 'quote-distribution/crate',
    name: 'quote-distribution-create',
    component: () => import('@/views/pages/quote-distribution/Create.vue'),
    meta: {
      pageTitle: 'Quote distribution',
      breadcrumb: [
        {
          to: { name: 'quote-distribution' },
          text: 'Quote distribution',
          active: false,
        },
        {
          text: 'Create',
          active: true,
        },
      ],
    },
    resource: 'Distribution',
  },
  {
    path: 'quote-distribution/:id',
    name: 'quote-distribution-get',
    component: QuoteDistributionRouter,
    props: { variant: 'wrapper' },
    redirect: { name: 'quote-distribution-view' },
    children: [
      {
        path: '',
        name: 'quote-distribution-view',
        component: QuoteDistributionRouter,
        props: { variant: 'detail' },
        meta: {
          pageTitle: 'View',
          breadcrumb: [
            {
              to: { name: 'quote-distribution' },
              text: 'Quote distribution',
              active: false,
            },
            {
              text: 'View',
              active: true,
            },
          ],
        },
        resource: 'Distribution',
      },
      // Quyidagilar faqat OTM/ITM rolida ishlatiladi
      {
        path: 'ask-list',
        name: 'quote-distribution-ask-list',
        component: () => import('@/views/pages/quote-distribution-otm/ask/List.vue'),
        meta: {
          pageTitle: 'Ask list',
          breadcrumb: [
            {
              to: { name: 'quote-distribution' },
              text: 'Quote distribution list',
              active: false,
            },
            {
              to: { name: 'quote-distribution-view' },
              text: 'Quote distribution',
              active: false,
            },
            {
              text: 'Additional distribution list',
              active: true,
            },
          ],
        },
        resource: 'Distribution',
      },
      {
        path: 'additional-dist',
        name: 'quote-distribution-additional-dist',
        component: () => import('@/views/pages/quote-distribution-otm/ask/distribute/View.vue'),
        meta: {
          pageTitle: 'Ask list',
          breadcrumb: [
            {
              to: { name: 'quote-distribution' },
              text: 'Quote distribution list',
              active: false,
            },
            {
              to: { name: 'quote-distribution-view' },
              text: 'Quote distribution',
              active: false,
            },
            {
              text: 'Distribute additional quote',
              active: true,
            },
          ],
        },
        resource: 'Distribution',
      },
      {
        path: 'ask-list/:totalQuoteId',
        name: 'ask-view',
        component: () => import('@/views/pages/quote-distribution-otm/ask/View.vue'),
        meta: {
          pageTitle: 'Ask view',
          breadcrumb: [
            {
              to: { name: 'quote-distribution' },
              text: 'Quote distribution list',
              active: false,
            },
            {
              to: { name: 'quote-distribution-view' },
              text: 'Quote distribution',
              active: false,
            },
            {
              to: { name: 'quote-distribution-ask-list' },
              text: 'Additional distribution list',
              active: false,
            },
            {
              text: 'Additional distribution',
              active: true,
            },
          ],
        },
        resource: 'Distribution',
      },
    ],
  },
]
